module.exports = __webpack_public_path__ + "static/media/arrow-right.d885e365.svg";